<template>
  <transition name="slide">
    <div
      v-if="isRxConfiguratorOverlayOpen"
      ref="rxScrollContainer"
      class="rx-configurator-scroller fixed left-0 top-0 z-50 m-0 h-screen max-h-dvh w-screen overflow-y-auto bg-white"
    >
      <div
        v-if="!isRxConfiguratorLoaded"
        class="grid h-screen place-items-center"
      >
        <LoadingBar
          class="w-2/5"
          :loading-text="$t('pdp.correctional_glasses.loading')"
          :animation-duration="rxLoadingAnimationDuration"
          @loaded="isRxConfiguratorLoaded = true"
        />
      </div>
      <RxConfigurator
        :frame-product="config.product"
        :frame-variant="config.variant"
        :initial-step="config.initialStep"
        :has-prescription-values="config.hasPrescriptionValues"
        :editing-group-id="config.editingGroupId"
        @click:close="onClickClose"
        @add-to-basket="(e: any) => $emit('addToBasket', e)"
        @add-frame-to-basket="() => $emit('addFrameToBasket')"
        @step:changed="scrollToTop()"
        @click:cancel-prescription-editor="scrollToTop()"
        @on-vto-open="() => $emit('onVtoOpen')"
      />
    </div>
  </transition>
</template>

<script setup lang="ts">
import useUiState from '~/composables/ui/useUiState'
import type { RxConfiguratorProps } from '~/components/rx/RxConfigurator/RxConfigurator'

defineProps({
  config: {
    type: Object as PropType<RxConfiguratorProps>,
    required: true,
  },
})

const emit = defineEmits<{
  (
    e: 'addToBasket',
    value: {
      itemsSerialized: ConfiguratorSerialized
      rxConfiguration: ConfiguratorState
    },
  ): void
  (e: 'addFrameToBasket' | 'close' | 'onVtoOpen'): void
}>()

const isRxConfiguratorLoaded = ref(false)
const { isRxConfiguratorOverlayOpen } = useUiState()
const rxScrollContainer = useTemplateRef('rxScrollContainer')

const scrollToTop = async () => {
  await nextTick()
  rxScrollContainer?.value?.scrollTo({ top: 0, behavior: 'smooth' })
}

const onClickClose = () => {
  isRxConfiguratorLoaded.value = false
  emit('close')
}
</script>
